<mat-dialog-content>
  <h1>We found some errors:</h1>

  <ul>
    @for(error of data.errors; track error.type) {
      <li>{{error.message}}</li>
    }
  </ul>

</mat-dialog-content>


<mat-dialog-actions>
  <button mat-raised-button mat-dialog-close>Close</button>
</mat-dialog-actions>